import './CreateAOFirstt.scss';

import { InfoOutlined } from '@mui/icons-material';
import { Button, FormControl, FormControlLabel, Radio,RadioGroup, Tooltip} from '@mui/material';
import React, { useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { buttonStyles, buttonStylesBlue } from '../../../Components/docsAdministrative/JsObjectStyles';
import { TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import SearchEntreprise from '../../../Components/shared/SearchEntreprise';
import SearchUser from '../../../Components/shared/SearchUser';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useCraRdv from '../../../hooks/useCraRdv';
import useFormValidation from '../../../hooks/useFormValidation';
import usePostRequest from '../../../hooks/usePostRequest';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import { isHttpStatusSuccess } from '../../../Utils/utils';
import CreateAOButtonsHeader from './CreateAOButtonsHeader';
function CreateAONext() {
    const { setBackdropOpen, setOpenSnackBar, setSnackBarMessage,setShowErrors, setErrors, } = useUtilities();
    const { setSelectedAO } = useCraRdv();
    const axiosPrivate = useAxiosPrivate();
    const role = useRole();
    const { postData } = usePostRequest();
    const [selectedType, setSelectedType] = useState('client');
    const location = useLocation();
    let navigate = useNavigate();
    const {device}=useWindowSize();
    const [nomEntrepriseConfidentiel, setnomEntrepriseConfidentiel] = useState(true);
    const [responsableAchat, setResponsableAchat] = useState();
    const [responsableComptabilite, setResponsableComptabilite] = useState();
    const [responsableOperationnel, setResponsableOperationnel] = useState();
    const [intitulePoste, setIntitulePoste] = useState();
    const [client, setClient] = useState();
    const { i18n } = useTranslation();
    // const { data: clientCompany } = useGetRequest({ url: `/${role}/getMyCompanyProfile`, propertyName: 'profileEntreprise' });
    const [clientCompany, setClientCompany] = useState(null);

    const handleSelect = (event) => {
        setSelectedType(event.target.value); // Extract the value from the event object
    };

    const getMyCompanyProfile = async () => {
        setBackdropOpen(true);
        try {
            const response = await axiosPrivate.get(`/${role}/getMyCompanyProfile`);
            setBackdropOpen(false);
            console.log(response);
            setClientCompany(response?.data?.profileEntreprise);
            // setSnackBarMessage(response?.data?.message);
            // setOpenSnackBar(true);
        } catch (error) {
            setBackdropOpen(false);
            console.log(error.response?.status,error.response?.data.error);
            setSnackBarMessage(i18n.t(error.response?.data.error));
            setOpenSnackBar(true);
        }
    };

    useEffect(() => {
        if (role) {
            getMyCompanyProfile();
        }
    }, [role]);

    const [isValid] = useFormValidation([
        { name: 'responsableOperationnel', value: responsableOperationnel },
        { name: 'responsableAchat', value: responsableAchat },
        { name: 'responsableComptabilite', value: responsableComptabilite },
    ]);
    useEffect(()=>{
        if(location?.state?.aoId){
            getAoDataById();
        }
    },[location?.state?.aoId]);
    // * ah changement du client par l'ADMIN (more work needed)
    useEffect(()=>{
        if(!client?._id){
            setResponsableAchat(null);
            setResponsableComptabilite(null);
            setResponsableOperationnel(null);
        }
    },[client]);

    const createAO_step1 = async () => {
        let response1;
        let collaboratorIds={};
        if(role=='esn' || (role=='admin' && selectedType=='esn')){
            collaboratorIds = {
            // * we set it into Ids only inside the SearchUser / onchange
            // responsableAchatId: responsableAchat?._id,
            // responsableOperationnelId: responsableOperationnel?._id,
            // responsableComptabiliteId: responsableComptabilite?._id,
                responsableAchatEsnId: responsableAchat?._id??responsableAchat,
                responsableOperationnelEsnId: responsableOperationnel?._id??responsableOperationnel,
                responsableComptabiliteEsnId: responsableComptabilite?._id??responsableComptabilite,

            };}
        else{
            collaboratorIds = {
            // * we set it into Ids only inside the SearchUser / onchange
            // responsableAchatId: responsableAchat?._id,
            // responsableOperationnelId: responsableOperationnel?._id,
            // responsableComptabiliteId: responsableComptabilite?._id,
                responsableAchatId: responsableAchat?._id??responsableAchat,
                responsableOperationnelId: responsableOperationnel?._id??responsableOperationnel,
                responsableComptabiliteId: responsableComptabilite?._id??responsableComptabilite,

            };}

        // * in case of modification
        if (location?.state?.aoId) {
            {      response1 = await postData({
                url: `/ao/updateAOById/${location?.state?.aoId}`, payload: {
                    // ! AMDIN case
                    companyDataId: client?._id,
                    entrepriseData : {
                        entrepriseName: clientCompany?.nom,
                        nomEntrepriseConfidentiel,
                        ...collaboratorIds
                    }
                },
            });}
        }
        // * in case of creation
        else {
            response1 = await postData({
                url: '/ao/createAO_step1', payload: {
                    nomEntrepriseConfidentiel,
                    // ! AMDIN case
                    companyDataId: client?._id,
                    ...collaboratorIds
                },
            });
            if (isHttpStatusSuccess(response1.responseStatus)) {
                // let stateToPass = {
                //     rowData: response1?.data?.createdAO
                // };
                // console.log({ stateToPass });
                // setSelectedAO(stateToPass);
                // setSelectedAO({ ...response1?.data?.createdAO,responsableOperationnel});
                setSelectedAO(response1?.data?.createdAO);
                navigate(`/${role}/createAO/next`); // selected AO is much better  than: {state:{aoId:ao?._id}}
            }
        }
        console.log(response1);
    };

    const getAoDataById = async () => {
        setBackdropOpen(true);
        try {
            // * the order is very important
            const response = await axiosPrivate.get('/ao/getMyAoById/' + location?.state?.aoId);
            console.log('response', response?.data?.myAO);
            setClient(response?.data?.myAO?.companyDataId);
            setSelectedAO(response?.data?.myAO);
            setnomEntrepriseConfidentiel(response?.data?.myAO?.entrepriseData?.nomEntrepriseConfidentiel);
            setResponsableOperationnel(response?.data?.myAO?.entrepriseData?.responsableOperationnelId ?? response?.data?.myAO?.entrepriseData?.responsableOperationnelEsnId);
            setResponsableComptabilite(response?.data?.myAO?.entrepriseData?.responsableComptabiliteId ?? response?.data?.myAO?.entrepriseData?.responsableComptabiliteEsnId);
            setResponsableAchat(response?.data?.myAO?.entrepriseData?.responsableAchatId ?? response?.data?.myAO?.entrepriseData?.responsableAchatEsnId);
            setIntitulePoste(response?.data?.myAO?.intitulePoste);

            setBackdropOpen(false);
        } catch (error) {
            console.log(error);
            setBackdropOpen(false);
        }
    };
    return (
        <form className='Frame10211'>
            <div className='Frame237679'>
                <CreateAOButtonsHeader
                    aoId={location?.state?.aoId}
                    intitulePoste={intitulePoste}
                    role={role}
                />
                <div className='DetailsPublication'>
                    <h6 className='nomPrenomProfile'>{i18n.t('Données entreprises')}</h6>
                    {role == 'admin' &&
                    <div className='Frame010101'>
                        <FormControl style={{display:'flex',flexDirection:'row',gap:'16px'}}>
                            <p className='IntitulePoste'>{i18n.t('Choisir un type')}</p>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue="client"
                                name="radio-buttons-group"
                                value={selectedType}
                                onChange={handleSelect}
                                style={{display:'flex',flexDirection:'row',gap:'8px'}}
                            >
                                <FormControlLabel
                                    value="esn"
                                    control={<Radio />}
                                    label="ESN"
                                />
                                <FormControlLabel
                                    value="client"
                                    control={<Radio />}
                                    label="Entreprise"
                                />
                            </RadioGroup>
                        </FormControl>
                    </div>
                    }
                    <div className='B1Pub1'>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'>{i18n.t('Entreprise')} </p>
                            { (role== 'admin' && !location?.state?.aoId) ?
                                (
                                    <SearchEntreprise
                                        width={'100%'}
                                        setClient={setClient}
                                        name={selectedType}
                                    />
                                ) :
                                <TextFieldComponent
                                    sx={{
                                        '& > :not(style)': {borderRadius: '8px'},
                                    }}
                                    type="text"
                                    name="Entreprise"
                                    autoComplete="off"
                                    disabled
                                    value={clientCompany?.nom || client?.profileEntreprise?.nom || '...loading'}
                                    style={{width:'100%'}}
                                />
                            }
                        </div>
                        <div className='Frame10129'>
                            <p className='IntitulePoste'> {i18n.t('Confidentielle')} </p>
                            <div className='CheckBox1'>
                                <input
                                    type="checkbox"
                                    onClick={() => {setnomEntrepriseConfidentiel(!nomEntrepriseConfidentiel);}}
                                    checked={nomEntrepriseConfidentiel}
                                    style={{
                                        width: '20px',
                                        borderRadius:'5px',
                                    }}
                                    required
                                />
                                <label
                                    className='checkBoxTitle'
                                    htmlFor="inlineRadio1"
                                >
                                    {i18n.t('Masquer le nom de l\'entrerprise.')}
                                </label>
                            </div>
                            {/*<div className='checkBoxTitle'>
                                    Si vous ne souhaitez pas que le nom de votre entreprise apparait.
                                </div>
                                */}
                        </div>
                    </div>
                </div>
                <div className='DetailsPublication'>
                    <h6 className='nomPrenomProfile'> {i18n.t('Cadres administratifs du projet')} &nbsp; &nbsp;
                        <Tooltip title={i18n.t('L\'équipe est requise pour créer une mission. L\'admin pourra affecter plus qu\'un rôle au même collaborateur.')}>
                            <InfoOutlined />
                        </Tooltip>
                    </h6>
                    <div className='B1Pub1'>
                        <div className='Frame101299'>
                            <p className='IntitulePoste'>{i18n.t('Responsable opérationnel')}</p>
                            {role && (
                                <SearchUser
                                    width={'100%'}
                                    size={'medium'}
                                    userType={role=='esn' ? 'Esn':'Client'}
                                    setUser={setResponsableOperationnel}
                                    // userId={responsableOperationnel?._id??responsableOperationnel}
                                    userId={responsableOperationnel}
                                    companyId={client?._id}
                                    name='responsableOperationnel'
                                />
                            )}
                        </div>
                        <div className='Frame101299'>
                            <p className='IntitulePoste'>{i18n.t('Responsable achat')} </p>
                            {role && (
                                <SearchUser
                                    userType={role=='esn' ? 'Esn':'Client'}
                                    setUser={setResponsableAchat}
                                    // placeholder={'Choisir...'}
                                    // userId={responsableAchat?._id??responsableAchat}
                                    userId={responsableAchat}
                                    companyId={client?._id}
                                    width={'100%'}
                                    name='responsableAchat'
                                />
                            )}
                        </div>
                        <div className='Frame101299'>
                            <p className='IntitulePoste'>{i18n.t('Comptable')} </p>
                            {role && (
                                <SearchUser
                                    userType={role=='esn' ? 'Esn':'Client'}
                                    // placeholder={'Choisir...'}
                                    // userId={responsableComptabilite?._id??responsableComptabilite}
                                    userId={responsableComptabilite}
                                    setUser={setResponsableComptabilite}
                                    companyId={client?._id}
                                    width={'100%'}
                                    name='responsableComptabilite'
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div className='Frame010101'>
                    {location?.state?.aoId &&
                    <Button
                        style={{...buttonStyles(false),...{width:device=='desktop'?'auto':'100%'}}}
                        variant="outlined"
                        onClick={(e) => {
                            e.preventDefault();
                            navigate(`/${role}/aos`);
                        }}
                    >
                        {i18n.t('Retour aux AO')}
                    </Button>
                    }
                    <Button
                        //style={{backgroundColor: '#214DCE', width: '150px', height: '56px',fontFamily: 'Lato',fontStyle: 'normal',fontWeight: 600,fontSize: '20px',lineHeight: '32px', alignItems: 'center',textAlign: 'center',letterSpacing: '-0.15px',color: 'white',borderRadius:'8px'}}
                        style={{...buttonStylesBlue(false),...{width:device=='desktop'?'auto':'100%'}}}
                        type="submit"
                        className='ButtonSubmit'
                        onClick={(e) => {
                            e.preventDefault();
                            if (isValid) {
                                createAO_step1();
                                setShowErrors(false);
                                setErrors({});
                            }
                            else setShowErrors(true);
                        }}
                    >
                        {location?.state?.aoId ? i18n.t('Sauvegarder') : i18n.t('Suivant') }
                    </Button>
                </div>
            </div>
        </form>
    );
}

export default CreateAONext;

